<template>
    <Menu theme="dark" :open-names="open" width="auto" :active-name="activeName" :class="menuTitleClasses">
        <template v-for="(item, index) in routes.filter(obj => { return obj.type === '0'})">
            <Submenu :name="item.name" :key="index">
                <template slot="title">
                    <Icon type="ios-navigate"></Icon>
                    <span>{{item.name}}</span>
                </template>
                <MenuItem v-for="child in item.children" @click.native="toPath(child)" :key="child.id" :name="child.name" :class="menuitemClasses">{{child.name}}</MenuItem>
            </Submenu>
        </template>
    </Menu>
</template>

<script>
export default {
    props: {
        collapsed: Boolean
    },
    data() {
        const opens = this.$route.matched[0].name;
        let name = this.$route.name;
        const routes = window.antRouter;
        return {
            open: [opens],
            activeName: name,
            routes: routes !== undefined ? routes : []
        };
    },
    computed: {
        menuTitleClasses() {
            return ['menu-item', this.collapsed ? 'collapsed-menuTitle' : ''];
        },
        menuitemClasses() {
            return ['menu-item', this.collapsed ? 'collapsed-menuItem' : ''];
        }
    },
    methods: {
        toPath(val) {
            if (val.href.indexOf('ftp:') !== -1) {
                this.activeName = this.$route.name;
                window.open(val.href, '_blank');
                return;
            }
            if (this.$route.path === val.path) {
                return;
            }
            this.$router.push(val.path);
        }
    }
};
</script>

<style scoped lang="scss">
.menu-item {
    white-space:nowrap;
}
.menu-item span{
    display: inline-block;
    overflow: hidden;
    width: 120px;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: bottom;
    transition: width .2s ease .2s;
}
.collapsed-menuTitle {
    span{
        width: 0px;
        transition: width .2s ease;
    }
    i{
        transform: translateX(5px);
        transition: font-size .2s ease .2s, transform .2s ease .2s;
        vertical-align: middle;
        font-size: 22px;
    }
}
.collapsed-menuItem {
    display: none;
}
</style>
<style scoped>
.collapsed-menuTitle >>> .ivu-menu-submenu-title-icon{
    display: none;
}
</style>
